import { observer } from "mobx-react-lite";
import { useVideoStore } from "../../../../shared/hooks/useVideoStore";
import { VideoCard } from "./components/VideoCard";
import { GallerySC, TitleSC, VideoGallerySC } from "./styled";

export const VideoGallery = observer(() => {
    const videoStore = useVideoStore();
    return (
        <VideoGallerySC>
            <TitleSC>Video Verification</TitleSC>
            <GallerySC>
                {videoStore.videos.map((video, index) => (
                    <VideoCard key={video.id} video={video} index={index} />
                ))}
            </GallerySC>
        </VideoGallerySC>
    );
});
